export const convertDateToISODate = (date: string, splitter: string) => {
    const parts = date.slice(date.indexOf(' ') + 1).split(splitter);
    if (parts.length !== 3) {
        return '';
    }

    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
};
